import React from "react";
import { getPrettyDate } from "../lib/format";

// The panel under a Program's matches in the pool lists: when betting opens and
// closes, the pool, its status and Program Code, statusButton (BET NOW or VIEW
// LIVE, which PoolItem and PoolItemWide link differently), and the Free2Play logo.
const PoolInformation = ({ item, statusButton }) => (
  <div className="panel poolinformation">
    Betting Opens: {getPrettyDate(item.poolOpenDate)}
    <br />
    Closes: {getPrettyDate(item.programDate) + " " + item.kickOffTime}
    <br />
    Current Pool: {item.poolTotal}
    {item.featured && item.poolStatus === "OPEN" ? (
      <>
        <br />
        <span style={{ color: "#e8004c" }}> {item.featured} </span>
      </>
    ) : null}
    <br />
    Status: {item.poolStatus}. Pool Code {item.programCode}
    <br />
    {statusButton}
    {item.free2Play ? (
      <a
        href={"https://www.tab.co.za/tabs/free/" + item.programDate + "/" + item.programCode + "/" + item.race}
        className="left"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://www.tab.co.za/assets/free-to-play/f2p-logo-blue.png"
          alt="free-2-play"
          style={{ width: "73px", height: "43px", marginTop: "15px" }}
        />
      </a>
    ) : (
      ""
    )}
  </div>
);

export default PoolInformation;
